const allowedAttributes = [ 'src', 'srcset', 'alt', 'title', 'width', 'height', 'loading', 'decoding', 'sizes', 'style' ];

const allowedDomains = [ 'pantheonsite.io', 'quickenloans.com', 'lowermybills.com'];

const isAllowedDomain = (url) => allowedDomains.some(domain => 
    url.includes(`.${domain}`)
)

const transform =(tagName, attribs) => 
{
    if (attribs?.src && isAllowedDomain(attribs?.src))
    {
        return { tagName, attribs };
    }
    const newAttribs = { ...attribs };
    delete newAttribs.src;
    return { tagName, attribs: newAttribs };
}

export default {
    allowedAttributes,
    transform,
}